import Loader from '@/components/common/Loader';
import { ScrollArea } from '@/components/ui/scroll-area';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';
import { Search } from 'lucide-react';

import { useCart } from '@/data/cart';
import CartItem from '@/app/cartItem/CartItem';
import CartSummary from '../CartSummary';
import CartActions from './CartActions';

const Cart = ({ cartId }) => {
  const cart = useCart(cartId);

  if (cart.isLoading && !cart.data) {
    return <Loader />;
  }

  if (cart.data.items.length === 0) {
    return (
      <Empty>
        <EmptyIcon>
          <Search />
        </EmptyIcon>
        <EmptyTitle>No Items in cart</EmptyTitle>
        <EmptyDescription>Go find your Pro!</EmptyDescription>
      </Empty>
    );
  }

  return (
    <div className="flex flex-col h-[100dvh]">
      <div
        className="flex-1 overflow-hidden relative"
        style={{ height: 'calc(100dvh - 200px)' }}
      >
        <ScrollArea className="h-[calc(100%-100px)]">
          <div className="space-y-4 py-2">
            {cart.data.items.map((cartItem) => (
              <CartItem cartItem={cartItem} key={cartItem.id} />
            ))}
          </div>
        </ScrollArea>
        <div className="absolute bottom-23 left-0 right-0 h-12 bg-gradient-to-t from-black/15 via-black/5 to-transparent pointer-events-none z-50" />
      </div>
      <div className="bg-background sticky bottom-6">
        <CartSummary cart={cart.data} />
        <CartActions cart={cart.data} />
      </div>
    </div>
  );
};

export default Cart;
